//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {formatTime} from "@/utils/common"
import {BASIC} from "@/config/constant"
import promise from '@/axios/promise';
export default{
    name :'',
    data(){
        return {
            list:'',
            week:'',
            starDay:'',
            year:'',
            month:0,
            index:0,
            data:{
               planMonth:'2018-11',
               currDate:'2018-11-27',
               signList:[], 
            },
            signData:{
               signTime:'',
               signPlace:'',
               signAddr:''
            }
        }
    },
    methods:{
        //返回
        goBack(){
            this.$router.go(-1);
        },
        //加在所在月份的数据
        getSignByMonth(){

            var dayStr=this.index+"";
            if(this.index<10){
                dayStr="0"+dayStr
            }
            var monthStr=""+this.month;
            if(this.month<10){
                monthStr="0"+monthStr
            }
            var signMonthDate=new Date(this.year+'-'+monthStr+'-'+dayStr); 

            var self=this;
            promise({
                url:BASIC+'/sign/signMonth',
                method:'get',
                params:{signMonth:formatTime(signMonthDate,'yyyy-MM')}
            }).then(res=>{
                if(res.code==0){
                    self.data.signList=res.data;
                    // var index=formatTime(new Date(),'dd')
                    self.getInfo(self.index);
                }
            });
        },
         mGetDate(year, month){
            var d = new Date(year, month, 0);
            return d.getDate();
        },
        dateRech(year,month){
            var dayNum=this.mGetDate(year,month);
            this.list=dayNum;
            //当前月当天日期对象：
            var starDate=new Date(year, month, 0);
            //当前月第一天日期对象：
            starDate=new Date(starDate.setDate(1))
            //当前月第一天星期几:
            var weekday=starDate.getDay()
            this.starDay=weekday;
            this.getSignByMonth();
        },
        getId(index){
            return "day"+index;
        },

        getClass(index){
            if(index==this.index){
                return "checkedDay";
            }
            return "";
        },


        //日历点击查看当天
        getInfo(index){
            this.index=index;
            var self=this;
            var dayStr=index;
            if(index<10){
                dayStr="0"+index;
            }
            var monthStr=""+this.month;
            if(this.month<10){
                monthStr="0"+monthStr
            }
            var date=this.year+'-'+monthStr+'-'+dayStr;
            var sign=undefined;
            for(var i=0;i<this.data.signList.length;i++){
                    var item=this.data.signList[i];
                    var  signTime=new Date(item.signTime) ;
                    if(formatTime(signTime,'yyyy-MM-dd') == formatTime(date,'yyyy-MM-dd')){
                        sign=item;
                    }
            }
            if(sign==undefined){
                    self.signData={signTime:'',signPlace:'',signAddr:''};
            }else{
                formatTime(new Date(sign.signTime),'hh:mm');
                self.signData.signTime=formatTime(new Date(sign.createTime),'hh:mm');
                self.signData.signPlace=sign.signPlace;
                self.signData.signAddr=sign.signAddr
            }
        },
        vueTouch:function(txt,e){
        if(txt=='左滑'){
            this.month+=1;
            if(this.month>12){
                this.year+=1;
                this.month=1;
            }
            this.dateRech(this.year,this.month);
        }else if(txt=='右滑'){
            this.month-=1;
            if(this.month<1){
                this.year-=1;
                this.month=12;
            }
            this.dateRech(this.year,this.month);
        }
    }
    },
    filters:{
        statusFilter(val,data){
            var dayStr=val;
            if(val<10){
                dayStr="0"+val
            }
            var monthStr=""+data.month;
            if(data.month<10){
                monthStr="0"+monthStr
            }
            var calDateStr=data.year+'-'+monthStr+'-'+dayStr;
            var date=new Date(calDateStr);
            var list=data.data.signList;
            var currDate=new Date();
            var myClass="";
            if(date>currDate){
                myClass+='unReach';
                return myClass;
            }else{
                var sign=undefined;
                for(var i=0;i<list.length;i++){
                        var item=list[i];
                        var  signTime=new Date(item.signTime) ;
                        if(formatTime(signTime,'yyyy-MM-dd') == formatTime(date,'yyyy-MM-dd')){
                            sign=item;
                        }
                }
                if(sign){
                    myClass+='signed';
                    return myClass;
                }else{
                    myClass+='unSign';
                    return myClass;
                }
            }
        }
    },
    created(){

    },
    mounted(){
        var data= new Date();
        var year =data.getFullYear();
        var month=data.getMonth()+1;
        var day=data.getDate();
        this.year=year;
        this.month=month;
        this.index=day;
        this.dateRech(this.year,this.month);
        // this.getInfo(day);
    }
}



// WEBPACK FOOTER //
// ./src/view/sign/signRecord.vue